import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instancex3sopkoseugu as EmptyIterator_instance } from './CollectionsKt.mjs';
import { iterator3f5i676wpaa3g as iterator } from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance2ztfx9zvq7j5d as Companion_instance,
} from './AbstractList.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.hasNext_bitz1p_k$())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        super($box);
        this.count_1 = this$0.size_1;
        this.index_1 = this$0.startIndex_1;
      }
      computeNext_o8do8q_k$() {
        if (this.count_1 === 0) {
          this.done_wskjm6_k$();
        } else {
          this.setNext_vbbbu2_k$(this.this$0__1.buffer_1[this.index_1]);
          var tmp = this;
          var tmp0 = this.this$0__1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp.index_1 = (this.index_1 + 1 | 0) % tmp0.capacity_1 | 0;
          this.count_1 = this.count_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      constructor(buffer, filledSize) {
        return new.target.new_kotlin_collections_RingBuffer_4grl9n_k$(buffer, filledSize);
      }
      static new_kotlin_collections_RingBuffer_4grl9n_k$(buffer, filledSize) {
        var $this = this.new_kotlin_collections_AbstractList_7zpyyf_k$();
        $this.buffer_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.buffer_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.buffer_1.length;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        $this.capacity_1 = $this.buffer_1.length;
        $this.startIndex_1 = 0;
        $this.size_1 = filledSize;
        return $this;
      }
      static new_kotlin_collections_RingBuffer_oqmmsx_k$(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.new_kotlin_collections_RingBuffer_4grl9n_k$(tmp$ret$0, 0);
      }
      get_size_woubt6_k$() {
        return this.size_1;
      }
      get_c1px32_k$(index) {
        Companion_instance.checkElementIndex_s0yg86_k$(index, this.size_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.startIndex_1 + index | 0) % this.capacity_1 | 0;
        return this.buffer_1[tmp$ret$0];
      }
      isFull_jiu7tz_k$() {
        return this.size_1 === this.capacity_1;
      }
      iterator_jk1svi_k$() {
        return new (RingBuffer$iterator$1())(this);
      }
      toArray_6cwqme_k$(array) {
        var tmp;
        if (array.length < this.size_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.size_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.size_1;
        var widx = 0;
        var idx = this.startIndex_1;
        while (widx < size && idx < this.capacity_1) {
          result[widx] = this.buffer_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          result[widx] = this.buffer_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_0 = terminateCollectionToArray(size, result);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      toArray_jjyjqa_k$() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.size_1;
        var tmp$ret$0 = Array(size);
        return this.toArray_6cwqme_k$(tmp$ret$0);
      }
      toArray() {
        return this.toArray_jjyjqa_k$();
      }
      expanded_jw31c1_k$(maxCapacity) {
        var newCapacity = coerceAtMost((this.capacity_1 + (this.capacity_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.startIndex_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.buffer_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.toArray_6cwqme_k$(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().new_kotlin_collections_RingBuffer_4grl9n_k$(newBuffer, this.size_1);
      }
      add_jcyd1a_k$(element) {
        if (this.isFull_jiu7tz_k$()) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.startIndex_1 + this.size_1 | 0) % this.capacity_1 | 0;
        this.buffer_1[tmp$ret$0] = element;
        this.size_1 = this.size_1 + 1 | 0;
      }
      removeFirst_dk12f8_k$(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.size_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.size_1;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        if (n > 0) {
          var start = this.startIndex_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.capacity_1 | 0;
          if (start > end) {
            fill(this.buffer_1, null, start, this.capacity_1);
            fill(this.buffer_1, null, 0, end);
          } else {
            fill(this.buffer_1, null, start, end);
          }
          this.startIndex_1 = end;
          this.size_1 = this.size_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
function windowedIterator$slambda($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  return constructCallableReference(($this$iterator, $completion) => orPromise($completion, function *($completion) {
    var bufferInitialCapacity = coerceAtMost($size, 1024);
    var gap = $step - $size | 0;
    var tmp;
    if (gap >= 0) {
      var buffer = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(bufferInitialCapacity);
      var skip = 0;
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $iterator;
      $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var e = _iterator__ex2g4s.next_20eer_k$();
        if (skip > 0) {
          skip = skip - 1 | 0;
          continue $l$loop;
        }
        buffer.add_utx5q5_k$(e);
        if (buffer.get_size_woubt6_k$() === $size) {
          yield* $this$iterator.yield_3xhcex_k$(buffer, $completion);
          if ($reuseBuffer) {
            buffer.clear_j9egeb_k$();
          } else
            buffer = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$($size);
          skip = gap;
        }
      }
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!buffer.isEmpty_y1axqb_k$()) {
        tmp_0 = $partialWindows || buffer.get_size_woubt6_k$() === $size ? (yield* $this$iterator.yield_3xhcex_k$(buffer, $completion)) : void 0;
      }
      tmp = tmp_0;
    } else {
      var buffer_0 = RingBuffer().new_kotlin_collections_RingBuffer_oqmmsx_k$(bufferInitialCapacity);
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = $iterator;
      $l$loop_0: while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var e_0 = _iterator__ex2g4s_0.next_20eer_k$();
        buffer_0.add_jcyd1a_k$(e_0);
        if (buffer_0.isFull_jiu7tz_k$()) {
          if (buffer_0.size_1 < $size) {
            buffer_0 = buffer_0.expanded_jw31c1_k$($size);
            continue $l$loop_0;
          }
          yield* $this$iterator.yield_3xhcex_k$($reuseBuffer ? buffer_0 : ArrayList().new_kotlin_collections_ArrayList_603np_k$(buffer_0), $completion);
          buffer_0.removeFirst_dk12f8_k$($step);
        }
      }
      var tmp_1;
      if ($partialWindows) {
        while (buffer_0.size_1 > $step) {
          yield* $this$iterator.yield_3xhcex_k$($reuseBuffer ? buffer_0 : ArrayList().new_kotlin_collections_ArrayList_603np_k$(buffer_0), $completion);
          buffer_0.removeFirst_dk12f8_k$($step);
        }
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!buffer_0.isEmpty_y1axqb_k$()) {
          tmp_2 = yield* $this$iterator.yield_3xhcex_k$(buffer_0, $completion);
        }
        tmp_1 = tmp_2;
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
